import { inspections } from './role'

export const queries = {
  inspections,
}
export default queries
